import type { CookieConsentProviderDefinition } from './cookie-consent.model';

/** Definición central de proveedores sujetos a consentimiento. */
export const OPTIONAL_CONSENT_PROVIDERS: CookieConsentProviderDefinition[] = [
  {
    id: 'clarity',
    label: 'Microsoft Clarity',
    description:
      'Herramienta de análisis de comportamiento para mejorar la experiencia de navegación.',
    relatedCookies: ['_clck', '_clsk', 'MUID'],
    configurable: true,
  },
  {
    id: 'googleAnalytics',
    label: 'Google Analytics',
    description:
      'Medición del uso del sitio web mediante Google Tag Manager / Analytics.',
    relatedCookies: ['_ga', '_gid', '_gat', '_gcl_au', 'FPID'],
    configurable: true,
  },
  {
    id: 'youtube',
    label: 'YouTube',
    description:
      'Reproducción de videos embebidos y contenido audiovisual de terceros.',
    relatedCookies: [
      'YSC',
      'VISITOR_INFO1_LIVE',
      '__Secure-YNID',
      '__Secure-ROLLOUT_TOKEN',
    ],
    configurable: true,
  },
];

export const COOKIE_MODAL_TEXT_PARAM = 'PAR-163';
export const COOKIE_POLICY_URL_PARAM = 'PAR-164';

/**
 * Botón "Aceptar": acepta todos los servicios modificables del canal.
 */
export const ACCEPT_ALL_PREFERENCES = {
  clarity: 'accepted',
  googleAnalytics: 'accepted',
  youtube: 'accepted',
} as const;

/** Cookies first-party opcionales eliminables al retirar consentimiento de Clarity. */
export const CLARITY_FIRST_PARTY_COOKIES = ['_clck', '_clsk'];

/** Cookies first-party de GA/GTM eliminables al retirar consentimiento de Analytics. */
export const ANALYTICS_FIRST_PARTY_COOKIES = ['_ga', '_gid', '_gat', '_gcl_au', 'FPID'];

/** Prefijos de cookies GA4/Universal (p. ej. _ga_XXXXXXXXX). */
export const ANALYTICS_FIRST_PARTY_COOKIE_PREFIXES = ['_ga_', '_gat', '_gac_'];
